import { combineReducers } from "@reduxjs/toolkit";
import onboardingReducer, { logOut } from "./onboardingSlice";
import campusReducer from "./campusSlice";
import organizationReducer from "./organizationSlice";
import locationReducer from "./locationSlice";
import assemblyReducer from "./assemblyPointSlice";
import zoneReducer from "./zoneSlice";
import courseReducer from "./courseSlice";
import fixtureReducer from "./fixtureSlice";
import profileReducer from "./profile";
import questTypePackageReducer from "./questTypePackageSlice";
import paymentMethodReducer from "./paymentMethodSlice";
import manageSubscriptionReducer from "./manageSubscriptionSlice";
import guideReducer from "./guideSlice";

const appReducer = combineReducers({
  onboarding: onboardingReducer,
  campus: campusReducer,
  organization: organizationReducer,
  location: locationReducer,
  assembly: assemblyReducer,
  zone: zoneReducer,
  course: courseReducer,
  fixture: fixtureReducer,
  user: profileReducer,
  questTypePackage: questTypePackageReducer,
  paymentMethod: paymentMethodReducer,
  manageSubscription: manageSubscriptionReducer,
  guide: guideReducer,
  // Add other slices here
});

const rootReducer = (state, action) => {
  if (
    action.type === logOut.fulfilled.type ||
    action?.meta?.cause === "UNAUTHENTICATE"
  ) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;